import { render, staticRenderFns } from "./search-recognition.vue?vue&type=template&id=7c3c5e5d&scoped=true&"
import script from "./search-recognition.vue?vue&type=script&lang=js&"
export * from "./search-recognition.vue?vue&type=script&lang=js&"
import style0 from "./search-recognition.vue?vue&type=style&index=0&id=7c3c5e5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c5e5d",
  null
  
)

export default component.exports